import { Component, computed, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {
  PermissionFeature,
  PermissionService,
} from '@price-management-console/permissions';
import {
  NavigationTabComponent,
  Tab,
} from '@price-management-console/shared-ui';

@Component({
  selector: 'app-header-nav',
  imports: [TranslateModule, NavigationTabComponent],
  templateUrl: './header-nav.html',
  styleUrl: './header-nav.scss',
  standalone: true,
})
export class HeaderNav {
  private readonly permissions = inject(PermissionService);
  mainTabs = computed<Tab[]>(() => [
    { label: 'NAV.HOME', path: '/home', disabled: false },
    {
      label: 'NAV.ROUTING_PROTOCOL',
      path: '/routing-protocol',
      disabled: !this.permissions.hasFeatureAccess(
        PermissionFeature.RoutingProtocol
      ),
    },
  ]);
}
